import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel';
import PlaceRolesForm from './PlaceRolesForm';
import PlaceRolesModel from './PlaceRolesModel';
import { Table, Popconfirm, Typography, Divider, message, Tooltip, Badge, Card, Row, Col } from 'antd';

class PlaceRolesTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    placeRoleSettingsFormData: null,
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={24}>
            <Card title="Aktivní hodiny">
              <ul style={{ listStyleType: 'none', paddingInline: '1rem', lineHeight: '1.5rem' }}>
                {record.activeHours ? Object.keys(record.activeHours).map((key, index) => {
                  var timesString = '';
                  const days = ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'];
                  record.activeHours[key].times.map((time, i) => {
                    timesString += `${moment().startOf('day').add(time.from, 'minutes').format('HH:mm')} - ${moment().startOf('day').add(time.to == 1440 ? 1439 : time.to, 'minutes').format('HH:mm')}`;
                    if (i < record.activeHours[key].times.length - 1) {
                      timesString += ', ';
                    }
                  })
                  const day = days[record.activeHours[key].weekday - 1];
                  return (
                    <li key={key}>
                      <b>{day}</b>:&nbsp;
                      <span key={index}>
                        {timesString}
                      </span>
                    </li>
                  )
                }) : null}
              </ul>
            </Card>
          </Col>

        </Row>
      </div >
    );
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Kód',
      dataIndex: 'code',
      key: 'code',
      width: 150,
      defaultSortOrder: 'ascend',
      sorter: (a, b) => defaultSorter(a.code, b.code)
    }, {
      title: 'Název',
      dataIndex: 'name',
      key: 'name',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => defaultSorter(a.name, b.name)
    }, {
      title: 'Státní svátky',
      dataIndex: 'holidays',
      key: 'holidays',
      render: (text, record) => {
        return record.holidays === true ? 'ANO' : 'NE'
      }
    }, {
      title: 'Priorita',
      dataIndex: 'priority',
      key: 'priority',
    }, {
      title: 'Aktivní',
      dataIndex: 'active',
      key: 'active',
      width: 100,
      render: (text, record) => {
        let now = moment().toISOString();
        if (record.active) {
          return (
            <Tooltip title='Je aktivní'>
              <Badge
                status="success" />
            </Tooltip>
          )
        } else {
          return (
            <Tooltip title='Není aktivní' >
              <Badge
                status="error" />
            </Tooltip>
          )
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 200,
      render: (text, record) => {
        if (record.code !== 'VEREJNE' && UserModel.isInRoles(['ADMIN', 'CORE_PLACEROLES_WRITE'])) {
          return (
            <React.Fragment>
              <a onClick={(e) => {
                this.setState({
                  placeRoleSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow
                  ? this.props.onRemoveRow(record.id)
                  : null;
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </React.Fragment>
          );
        }
      }
    }];

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          onChange={this.handleChange}
          expandedRowRender={this.expandedRowRender.bind(this)}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          style={{ border: '0px' }} />
        <PlaceRolesForm
          type="modal"
          modalVisible={this.state.placeRoleSettingsFormData === null ? false : true}
          initialValues={this.state.placeRoleSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ placeRoleSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            PlaceRolesModel.patch(this.state.placeRoleSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  placeRoleSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default PlaceRolesTable;


// WEBPACK FOOTER //
// ./src/components/PlaceRolesTable.js